import { render } from "./sync-brands.vue?vue&type=template&id=e8ad64cc"
import script from "./sync-brands.vue?vue&type=script&setup=true&lang=js"
export * from "./sync-brands.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/common/sync-brands.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e8ad64cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e8ad64cc', __exports__)) {
    console.log('reload')
    api.reload('e8ad64cc', __exports__)
  }
  
  module.hot.accept("./sync-brands.vue?vue&type=template&id=e8ad64cc", () => {
    console.log('re-render')
    api.rerender('e8ad64cc', render)
  })

}


export default __exports__